import Vue from 'vue'
import VueRouter from 'vue-router'
//一级路由入口
import WorkbenchIndex from '../views/home.vue'

Vue.use(VueRouter)
let originalPush = VueRouter.prototype.push;
let originalReplace = VueRouter.prototype.replace;

// 导航防抖锁
let routerPushLock = false;

// 释放锁的辅助函数
function releaseLock() {
  routerPushLock = false;
}

// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (routerPushLock) {
    console.warn('Navigation skipped: previous navigation in progress');
    return Promise.resolve();
  }
  
  routerPushLock = true;
  
  const result = originalPush.call(this, location, onResolve, onReject);
  
  // 检查 result 是否为 Promise
  if (result && typeof result.then === 'function') {
    if (onResolve || onReject) {
      return result.then(onResolve, onReject).finally(releaseLock);
    }
    return result.catch((err) => {
      if (err.name !== 'NavigationDuplicated') {
        throw err;
      }
    }).finally(releaseLock);
  } else {
    // 如果不是 Promise，同步释放锁
    releaseLock();
    return result;
  }
};

// replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (routerPushLock) {
    console.warn('Navigation skipped: previous navigation in progress');
    return Promise.resolve();
  }
  
  routerPushLock = true;
  
  const result = originalReplace.call(this, location, onResolve, onReject);
  
  // 检查 result 是否为 Promise
  if (result && typeof result.then === 'function') {
    if (onResolve || onReject) {
      return result.then(onResolve, onReject).finally(releaseLock);
    }
    return result.catch((err) => {
      if (err.name !== 'NavigationDuplicated') {
        throw err;
      }
    }).finally(releaseLock);
  } else {
    // 如果不是 Promise，同步释放锁
    releaseLock();
    return result;
  }
};
const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/callbackLogin',
    name: 'callbackLogin',
    component: () => import('../views/callbackLogin.vue'),
    meta: { title: '回调页' }
  },
  // 主框架路由
  {
    path: '/workbench',
    component: WorkbenchIndex,
    redirect: '/workbench/dashboard',
    children: [
      // 工作台
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/workbench/dashboard/index.vue'),
        meta: { title: '工作台' }
      },
      // 交易订单（原销售下单）
      {
        path: 'salesOrder',
        name: 'SalesOrder',
        component: () => import('../views/purchase/salesOrder/index.vue'),
        meta: { title: '交易订单' }
      },
      // 店铺管理（原销售店铺配置）
      {
        path: 'purchaseShopList',
        name: 'PurchaseShopList',
        component: () => import('../views/shop/purchaseShopList/index.vue'),
        meta: { title: '店铺管理' }
      },
      // 采购账号（原采购账号配置）
      {
        path: 'TaobaoShop',
        name: 'TaobaoShop',
        component: () => import('../views/shop/TaobaoShop/index.vue'),
        meta: { title: '采购账号' }
      },
      // 采购订单（1688订单）
      {
        path: 'purchaseOrder',
        name: 'PurchaseOrder',
        component: () => import('../views/purchase/purchaseOrder/index.vue'),
        meta: { title: '采购订单' }
      },
      // 地址管理（原通用地址配置）
      {
        path: 'ReturnAddress',
        name: 'ReturnAddress',
        component: () => import('../views/AddressConfiguration/ReturnAddress/index.vue'),
        meta: { title: '地址管理' }
      },
      // 退货地址配置
      {
        path: 'UniversalAddress',
        name: 'UniversalAddress',
        component: () => import('../views/AddressConfiguration/UniversalAddress/index.vue'),
        meta: { title: '退货地址配置' }
      },
      // 商品列表（原采购商品）
      {
        path: 'purchase',
        name: 'Purchase',
        component: () => import('../views/purchase/purchase/index.vue'),
        meta: { title: '商品列表' }
      },
      // 利润管理（原数据利润）
      {
        path: 'DataProfit',
        name: 'DataProfit',
        component: () => import('../views/Profit/DataProfit/index.vue'),
        meta: { title: '利润管理' }
      },
      // 账号管理（原子账号管理）
      {
        path: 'accountManagement',
        name: 'accountManagement',
        component: () => import('../views/useInfo/accountManagement/index.vue'),
        meta: { title: '账号管理' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router

